export function pushDataLayerEvent(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        ...payload,
        event_id: crypto.randomUUID(),
    });
}
